import { EntityType } from '@frontend/common';

import { ImageContainer } from '../../../image-container/image-container.component';

export interface ImageContainerWrapperProps {
    entity: any;
    entity_type: EntityType;
}

export const ImageContainerWrapper = (props: ImageContainerWrapperProps) => {
    return (
        <div className='inline-flex w-64 items-center justify-start self-stretch p-0'>
            <ImageContainer {...props} />
        </div>
    );
};
